import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import cautionImage from '../assets/images/landing/JPG/Source_4.jpg'

const Caution = () => {
  const { t } = useTranslation('caution')

  return (
    <>
      <section className='container no-margin home-regular'>
        <div className="caution">
          <div className="caution-title-wrapper">
            <h2>
              {t('caution.title')}
            </h2>
          </div>

          <div className="caution-columns">
            <div className="caution-image">
              <img src={cautionImage} alt='' />
            </div>

            <div className="caution-text">
              <p className='light'>{t('caution.instructions')}</p>
              <p className='light'>{t('caution.transactions_irreversible')}</p>
              <p className='light'>{t('caution.wallet_backup')}</p>
              <p className='light'>
                <Trans
                  t={t}
                  i18nKey='caution.scam_alert'
                  components={{ bold: <b /> }}
                />
              </p>
              <p className='light'>
                <Trans
                  t={t}
                  i18nKey='caution.volatility_warning'
                  components={{ bold: <b /> }}
                />
              </p>
            </div>
          </div>

          <div className="caution-footer">
            <i className="fas fa-exclamation-triangle" />
            {t('caution.contact_support')}
          </div>
        </div>
      </section>
    </>
  )
}

export default Caution
